// extracted by mini-css-extract-plugin
export default {"padding":"styles_padding__9tKKr"};